<template>
  <div>
    <div class="vx-row" v-show="mobileLoading || desktopLoading">
      <div id="loading" class="vs-con-loading__container"></div>
    </div>
    <div v-show="!mobile.length && !desktop.length" class="text-center pt-5">
      <h5 class="mb-2">CLIQUE AQUI E COMEÇE A INSTALAÇÃO</h5>
      <p class="text-grey">
        {{ $t('TextMessageAddDevice') }}
      </p>
      <router-link to="/novo-dispositivo">
        <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief mt-3">
          <span class="vs-button-text vs-button--text"> <i class="fas fa-plus"></i> {{ $t('AddDevice') }} </span>
          <span
            class="vs-button-linex"
            style="
              top: auto;
              bottom: -2px;
              left: 50%;
              transform: translate(-50%);
            "
          ></span>
        </button>
      </router-link>
    </div>
    <div v-show="!mobile.length && !desktop.length" class="text-center pt-5">
      <h5 class="mb-2">Fale com um Especialista</h5>
      <p class="text-grey">
        Se tem dúvida na instalação, fale conosco agora!
      </p>
      <a :href="`https://api.whatsapp.com/send?phone=5511976394983`">
        <button name="button" class="vs-component vs-button vs-button-success vs-button-relief mt-3">
          <span class="vs-button-text vs-button--text"> <i class="fab fa-whatsapp"></i> Fale com um Especialista </span>
          <span
            class="vs-button-linex"
            style="
              top: auto;
              bottom: -2px;
              left: 50%;
              transform: translate(-50%);
            "
          ></span>
        </button>
      </a>
    </div>
    <div class="vx-row" v-show="mobile.length">
      <div class="vx-col w-full mb-4 gap-x-4 justify-between flex items-center">
        <h1>{{ $t('Cell') }}</h1>
        <p
          class="p-2 font-bold px-4"
          style="border-radius: 10px; background-color: #00000010;"
          v-show="subscriptions.length && appName.indexOf('wSpy') > -1"
        >
          <i class="fab fa-whatsapp"></i> {{ $t('VIPService') }}
          <a href="https://wa.me/551130424024" target="_blank"> 11 3042 4024 </a>
        </p>
      </div>

      <div class="vx-col w-full mb-4">
        <div class="flex-1 px-2">
          <vs-input class="w-full inputx" placeholder="Nome do dispositivo" v-model="filters.device" />
        </div>
      </div>

      <div
        class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base mt-1"
        :device="device"
        :filters="filters"
        v-for="dispositivo in mobile"
        :key="dispositivo.uid"
      >
        <vx-card class="p-2 relative">
          <div
            v-if="!dispositivo.licence.active && !mobileVerifySubscriptionOnDevice(dispositivo.id)"
            class="flex flex-col gap-y-2 absolute blur-all bg-white-op items-center justify-center text-center w-full h-full top-0 left-0 rounded z-50"
          >
            <span class="p-2 rounded-full bg-red w-12 h-12 flex items-center justify-center">
              <vs-icon icon-pack="fa" icon="fa-exclamation" class="text-white text-xl"></vs-icon>
            </span>

            <h2 class="text-black font-semibold w-full mb-2 lg:text-lg">Falha no pagamento</h2>

            <button
              name="button"
              @click="planos(dispositivo)"
              class="vs-component vs-button vs-button-danger vs-button-relief w-[80%] mb-4"
            >
              <span class="vs-button-text vs-button--text">
                <vs-icon icon-pack="fa" icon="fa-lock"></vs-icon>&nbsp;{{ $t('regularize') }}
              </span>
              <span
                class="vs-button-linex"
                style="
                  top: auto;
                  bottom: -2px;
                  left: 50%;
                  transform: translate(-50%);
                "
              ></span>
            </button>
          </div>
          <div class="text-center background">
            <h4>{{ dispositivo.alias || dispositivo.device }}</h4>
            <p class="text-grey">{{ dispositivo.device }}</p>
            <p class="text-grey">{{ $t('LastUpdate') }} {{ dispositivo.updated_at | formatDateTime }}</p>
            <i class="mx-auto my-6 block fas fa-mobile-alt fa-4x text-primary"></i>
            <!-- action icons -->
            <div class="text-center">
              <a
                href="javascript:;"
                @click="transferirLicenca(dispositivo)"
                v-show="dispositivo.licence.active"
                class="px-6 text-success"
                title="Transferir Licença"
              >
                <i class="far fa-exchange" style="font-size: 1.3rem"></i>
              </a>

              <router-link
                :to="{ name: 'apagarDados', params: { uid: dispositivo.uid } }"
                class="px-6 text-danger"
                title="Apagar Dados"
              >
                <i class="far fa-eraser" style="font-size: 1.3rem"></i>
              </router-link>

              <a href="javascript:;" @click="renomearDispositivo(dispositivo)" class="px-6" title="Editar Apelido">
                <i class="far fa-edit" style="font-size: 1.3rem"></i>
              </a>

              <a
                href="javascript:;"
                @click="atualizarDispositivo(dispositivo)"
                class="px-6 text-success"
                title="Solicitar Atualização"
              >
                <i class="far fa-sync" style="font-size: 1.3rem"></i>
              </a>

              <a href="javascript:;" @click="excluirDispositivo(dispositivo)" class="px-6 text-danger" title="Excluir">
                <i class="far fa-trash" style="font-size: 1.3rem"></i>
              </a>
            </div>
          </div>

          <!-- device info -->
          <div class="flex justify-between text-center mt-4">
            <span>
              <p class="text-xl font-semibold">{{ dispositivo.version }}</p>
              <small class="text-grey">{{ $t('Android') }}</small>
            </span>
            <span>
              <p class="text-xl font-semibold">{{ dispositivo.apkversion }}</p>
              <small class="text-grey"> {{ $t('VersionWspy') }} </small>
            </span>
            <span v-if="dispositivo.licence.until">
              <p class="text-xl font-semibold">
                {{ dispositivo.licence.until | formatDate }}
              </p>
              <small class="text-grey">{{ $t('LicenseValidity') }}</small>
            </span>
            <span v-if="dispositivo.licence.trialUntil && dispositivo.licence.until === null">
              <p class="text-xl font-semibold">
                {{ dispositivo.licence.trialUntil | formatDate }}
              </p>
              <small class="text-grey">{{ $t('TestValidity') }}</small>
            </span>
          </div>

          <vs-alert icon="warning" active="true" color="danger" class="mt-5" v-show="dispositivo.delete_days_left">
            {{ $t('DELETE_NOTICE_PART_1') }} {{ dispositivo.delete_days_left }} {{ $t('DELETE_NOTICE_PART_2') }}
          </vs-alert>

          <vs-alert
            icon="warning"
            active="true"
            class="mt-5"
            v-show="!dispositivo.licence.active && !dispositivo.licence.trial"
          >
            {{ $t('TrialExpired') }}
          </vs-alert>

          <vs-alert
            icon="warning"
            active="true"
            color="danger"
            class="mt-5"
            v-show="!dispositivo.licence.active && !subscriptionVerify(dispositivo.id)"
          >
            Sua assinatura está suspensa por falha no pagamento, isso pode ocorrer por falta de limite, cancelamento de
            cartão ou algo parecido, regularize sua situação que o pagamento é feito automaticamente.
          </vs-alert>

          <!-- buttons -->
          <!-- view content button only if active/trial -->
          <a
            href="javascript:;"
            @click="visualizarConteudo(dispositivo)"
            v-show="dispositivo.licence.active || dispositivo.licence.trial"
          >
            <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief w-full mt-6">
              <span class="vs-button-text vs-button--text">
                <vs-icon icon-pack="fa" icon="fa-eye"></vs-icon>&nbsp;{{ $t('ViewData') }}
              </span>
              <span
                class="vs-button-linex"
                style="
                  top: auto;
                  bottom: -2px;
                  left: 50%;
                  transform: translate(-50%);
                "
              ></span>
            </button>
          </a>

          <!-- unlock content button -->
          <vs-alert
            icon="new_releases"
            active="true"
            color="success"
            class="mt-4"
            v-show="!dispositivo.licence.until && licencesMobile.length"
          >
            {{ $t('ReleaseLicense') }}
            <strong>{{ dispositivo.alias || dispositivo.device }}</strong>
            {{ $t('TextUnlock') }}
          </vs-alert>

          <a
            href="javascript:;"
            @click="planos(dispositivo)"
            v-show="!licencesMobile.length && dispositivo.licence.until"
          >
            <button name="button" class="vs-component vs-button vs-button-success vs-button-relief w-full mt-6">
              <span class="vs-button-text vs-button--text">
                <vs-icon icon-pack="fa" icon="fa-lock"></vs-icon>&nbsp;{{ $t('IncreaseValidity') }}
              </span>
              <span
                class="vs-button-linex"
                style="
                  top: auto;
                  bottom: -2px;
                  left: 50%;
                  transform: translate(-50%);
                "
              ></span>
            </button>
          </a>

          <router-link :to="'/mobile-desbloquear-conteudo/' + dispositivo.uid" v-show="licencesMobile.length">
            <button name="button" class="vs-component vs-button vs-button-success vs-button-relief w-full mt-6">
              <span class="vs-button-text vs-button--text" v-if="!dispositivo.licence.until">
                <vs-icon icon-pack="fa" icon="fa-lock-open"></vs-icon>&nbsp; {{ $t('UnlockContent') }}
              </span>
              <span class="vs-button-text vs-button--text" v-if="dispositivo.licence.until">
                <vs-icon icon-pack="fa" icon="fa-lock-open"></vs-icon>&nbsp; {{ $t('IncreaseValidity') }}
              </span>
              <span
                class="vs-button-linex"
                style="
                  top: auto;
                  bottom: -2px;
                  left: 50%;
                  transform: translate(-50%);
                "
              ></span>
            </button>
          </router-link>

          <!-- plans button -->
          <a href="javascript:;" @click="planos(dispositivo)" v-show="!dispositivo.licence.until">
            <button
              name="button"
              v-show="!dispositivo.licence.active && subscriptionVerify(dispositivo.id)"
              class="vs-component vs-button vs-button-primary vs-button-relief w-full mt-6"
            >
              <span class="vs-button-text vs-button--text">
                <vs-icon icon-pack="fa" icon="fa-lock"></vs-icon>&nbsp;
                <span v-if="!licencesMobile.length">{{ $t('ChoosePlan') }}</span>
                <span v-else>{{ $t('AllPlans') }}</span>
              </span>
              <span
                class="vs-button-linex"
                style="
                  top: auto;
                  bottom: -2px;
                  left: 50%;
                  transform: translate(-50%);
                "
              ></span>
            </button>
          </a>

          <a
            :href="`https://wa.me/${isCloudDomain ? '551130429641' : '551130423754'}`"
            v-show="!dispositivo.licence.until"
          >
            <button
              v-show="!dispositivo.licence.active && !subscriptionVerify(dispositivo.id)"
              name="button"
              class="vs-component vs-button vs-button-primary vs-button-relief w-full mt-6"
            >
              <span class="vs-button-text vs-button--text">
                <vs-icon icon-pack="fa" icon="fa-phone"></vs-icon>&nbsp;
                <span>Falar com atendente</span>
              </span>
              <span
                class="vs-button-linex"
                style="
                  top: auto;
                  bottom: -2px;
                  left: 50%;
                  transform: translate(-50%);
                "
              ></span>
            </button>
          </a>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" v-show="desktop.length">
      <div class="vx-col w-full mb-4">
        <h1>{{ $t('Computer') }}</h1>
      </div>

      <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base" v-for="dispositivo in desktop" :key="dispositivo.licencekey">
        <vx-card class="p-2">
          <div class="text-center">
            <h4>{{ dispositivo.alias || '-' }}</h4>
            <p class="text-grey">
              {{ dispositivo.updated_at | formatDateTime }}
            </p>
            <i class="mx-auto my-6 block fas fa-desktop-alt fa-4x text-primary text-center"></i>
            <vs-row>
              <vs-col class="text-right" vs-w="4">
                <router-link
                  :to="{ name: 'apagarDadosComputador', params: { uid: dispositivo.licencekey } }"
                  class="px-6 text-danger"
                  title="Apagar Dados"
                >
                  <i class="far fa-eraser" style="font-size: 1.3rem"></i>
                </router-link>
              </vs-col>
              <vs-col class="text-right" vs-w="4">
                <a href="javascript:;" @click="renomearDispositivo(dispositivo)" class="px-6">
                  <i class="far fa-edit" style="font-size: 1.3rem"></i>
                </a>
              </vs-col>
              <vs-col class="text-left" vs-w="4">
                <a href="javascript:;" @click="excluirDispositivo(dispositivo)" class="px-6">
                  <i class="far fa-trash text-danger" style="font-size: 1.3rem"></i>
                </a>
              </vs-col>
            </vs-row>
          </div>
          <br />
          <div class="flex justify-between text-center">
            <span>
              <p class="text-xl font-semibold">{{ $t('License') }}</p>
              <small class="text-grey">{{ dispositivo.licencekey }}</small>
            </span>
            <span>
              <p class="text-xl font-semibold">{{ $t('ShelfLife') }}</p>
              <small class="text-grey">{{ dispositivo.licence_valid_until | formatDate }}</small>
            </span>
          </div>
          <a href="javascript:;" @click="visualizarConteudoPc(dispositivo)">
            <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief w-full mt-6">
              <span class="vs-button-text vs-button--text"> <i class="fa fa-eye"></i> {{ $t('ViewData') }} </span>
              <span
                class="vs-button-linex"
                style="
                  top: auto;
                  bottom: -2px;
                  left: 50%;
                  transform: translate(-50%);
                "
              ></span>
            </button>
          </a>
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base" v-for="licence in licencesCloud" :key="licence.id">
        <vx-card class="p-2">
          <div class="text-center mb-6">
            <h4>{{ $t('Available') }}</h4>
            <p class="text-grey">{{ licence.date_added | formatDateTime }}</p>
            <i class="mx-auto my-6 block fas fa-desktop-alt fa-4x text-success text-center"></i>
          </div>
          <div>&nbsp;</div>
          <div class="flex justify-between text-center mt-6">
            <span>
              <p class="text-xl font-semibold">{{ $t('License') }}</p>
              <small class="text-grey">{{ licence.licencekey }}</small>
            </span>
            <span>
              <p class="text-xl font-semibold">{{ $t('ShelfLife') }}</p>
              <small class="text-grey" v-if="licence.months == 1"> {{ $t('OneMonth') }} </small>
              <small class="text-grey" v-else-if="licence.months > 1">{{ licence.months }} {{ $t('Months') }} </small>
              <small class="text-grey" v-else-if="licence.days == 1">1 {{ $t('Day') }}</small>
              <small class="text-grey" v-else-if="licence.days > 1">{{ licence.days }} {{ $t('Days') }}</small>
            </span>
          </div>

          <a href="https://www.wtsoftware.com.br/download-exe.html">
            <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief w-full mt-6">
              <span class="vs-button-text vs-button--text">
                <i class="fab fa-windows"></i> {{ $t('DownloadNow') }}
              </span>
              <span
                class="vs-button-linex"
                style="
                  top: auto;
                  bottom: -2px;
                  left: 50%;
                  transform: translate(-50%);
                "
              ></span>
            </button>
          </a>
        </vx-card>
      </div>
    </div>
    <vs-prompt
      @cancel="renomear.visivel = false"
      @accept="renomearDispositivoSalvar"
      @close="renomearDispositivoCancelar"
      :active.sync="renomear.visivel"
      :accept-text="'Salvar'"
      :cancel-text="'Cancelar'"
      :title="'Alterar Apelido do Dispositivo'"
    >
      <div>
        <vs-input placeholder="Digite o novo apelido" v-model="renomear.alias" />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  data() {
    return {
      desktop: [],
      subscriptions: [],
      desktopLoading: true,
      mobile: [],
      mobileLoading: true,
      renomear: {
        visivel: false,
        alias: '',
        dispositivo: {}
      },
      filters: {
        device: null
      },
      licencesMobile: [],
      licencesCloud: [],
      appName: process.env.VUE_APP_NAME
    };
  },
  computed: {
    mobileRegisteredCount() {
      return this.mobile.filter(m => m.licence.active).length;
    },
    mobileNotRegisteredCount() {
      return this.mobile.filter(m => !m.licence.active).length;
    },
    subscriptionVerify() {
      return id => {
        const subscription = this.subscriptions.find(s => s.device_id === id);

        if (subscription && subscription.renew_at) {
          const renewAtDate = new Date(subscription.renew_at);
          const today = new Date();

          if (renewAtDate >= today) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      };
    },
    mobileVerifySubscriptionOnDevice() {
      return id => {
        const subscription = this.subscriptions.find(s => s.device_id === id);
        const hasSubscriptionWithoutDeviceId = this.subscriptions.some(s => !s.device_id && s.status === 'Ativa');

        if (!hasSubscriptionWithoutDeviceId) {
          if (subscription) {
            if (subscription.status === 'Suspensa') {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          return true;
        }
      };
    },
    isCloudDomain() {
      return window.location.origin.startsWith('https://cloud.wtsoftware.com.br');
    }
  },
  mounted: function() {
    // this.$notification.requestPermission();

    this.$vs.loading({
      container: '#loading',
      type: 'default',
      scale: 1
    });

    // Reinicia o menu
    this.$EventBus.$emit('deviceChanged', null);

    this.carregarDispositivos();

    this.$api
      .get('/api/v1/licence/list')
      .then(response => {
        this.licencesMobile = response.data.filter(l => l.product.type === 'MOBILE');
        this.licencesCloud = response.data.filter(l => l.product.type === 'CLOUD' && l.licencekey && !l.device_id);
      })
      .catch(() => {});
  },
  methods: {
    carregarDispositivos: function() {
      // desktop
      this.$api
        .get('/api/v1/desktop/device')
        .then(response => {
          this.desktopLoading = false;
          this.desktop = response.data.data;
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });

      this.$api
        .get('/api/v1/subscription')
        .then(response => {
          this.loadingSession = false;
          this.loading = false;
          this.subscriptions = response.data;
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });

      // mobile
      this.$api
        .get('/api/v1/mobile/device')
        .then(response => {
          this.mobileLoading = false;
          this.mobile = response.data.data;

          // Apply the device filter
          if (this.filters.device) {
            this.mobile = this.mobile.filter(
              device =>
                device.device.toLowerCase().includes(this.filters.device.toLowerCase()) ||
                (device.alias && device.alias.toLowerCase().includes(this.filters.device.toLowerCase()))
            );
          }
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    visualizarConteudo: function(dispositivo) {
      this.$localStorage.set('panel_version', dispositivo.panel_version);
      this.$localStorage.set('uuid', dispositivo.uuid);
      this.$localStorage.set('uid', dispositivo.uid);
      this.$EventBus.$emit('deviceChanged', dispositivo);
      this.$router.push('/mobile/dashboard');
    },
    transferirLicenca: function(dispositivo) {
      this.$localStorage.set('deviceTransfer', JSON.stringify(dispositivo));
      if (dispositivo.uid) {
        this.$router.push('/transferir-licenca-dispositivo/mobile/' + dispositivo.uid);
      } else {
        this.$router.push('/transferir-licenca-dispositivo/desktop/' + dispositivo.licencekey);
      }
    },
    planos: function(dispositivo) {
      if (dispositivo.uid) {
        this.$router.push(`/planos/mobile/${dispositivo.uid}/1`);
      }

      if (!dispositivo.uid) {
        this.$router.push(`/planos/desktop/${dispositivo.id}/3`);
      }
    },
    visualizarConteudoPc: function(dispositivo) {
      this.$localStorage.set('licencekey', dispositivo.licencekey);
      this.$EventBus.$emit('deviceChanged', dispositivo);
      this.$router.push('/desktop/dashboard');
    },

    openAlert(color) {
      this.colorAlert = color;
      this.$vs.dialog({
        color: this.colorAlert,
        title: `Texto pra liberar licenca - ${this.colorAlert}`,
        text:
          'Texto pra liberar, texto pra liberar Texto pra liberar, texto pra liberar Texto pra liberar, texto pra liberar Texto pra liberar, texto pra liberar Texto pra liberar, texto pra liberar .',
        accept: this.acceptAlert
      });
    },
    renomearDispositivo(dispositivo) {
      this.renomear.dispositivo = dispositivo;
      this.renomear.alias = dispositivo.alias || dispositivo.alias || dispositivo.device;
      this.renomear.visivel = true;
    },
    atualizarDispositivo(dispositivo) {
      this.$api
        .get(`/api/v${dispositivo.panel_version}/mobile/command/${dispositivo.uid}/update`)
        .then(() => {
          this.$vs.notify({
            title: 'Informação',
            text: 'Comando enviado. Assim que o dispositivo estiver online, os dados serão sincronizados.',
            color: 'success'
          });

          setTimeout(() => {
            this.carregarDispositivos();
          }, 10000);
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    renomearDispositivoSalvar() {
      this.renomear.visivel = false;

      // Mobile
      if (this.renomear.dispositivo.uid) {
        this.$api
          .post('/api/v1/mobile/updateAlias/' + this.renomear.dispositivo.uid, {
            alias: this.renomear.alias
          })
          .then(response => {
            this.mobile.forEach(i => {
              if (i.uid == this.renomear.dispositivo.uid) {
                i.alias = response.data.data.alias;
              }
            });

            this.$vs.notify({
              time: 6000,
              text: 'Apelido Salvo com Sucesso',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });
          })
          .catch(() => {
            this.$vs.notify({
              time: 6000,
              title: 'Aviso',
              text: 'Erro ao renomear dispositivo. Tente novamente.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          });
      }

      // Desktop
      if (this.renomear.dispositivo.licencekey) {
        this.$api
          .post('/api/v1/desktop/update', {
            dispositivo: this.renomear.dispositivo,
            alias: this.renomear.alias
          })
          .then(response => {
            this.desktop.forEach(i => {
              if (i.licencekey == this.renomear.dispositivo.licencekey) {
                i.alias = response.data.data.alias;
              }
            });

            this.$vs.notify({
              time: 6000,
              text: 'Apelido Salvo com Sucesso',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });
          })
          .catch(() => {
            this.$vs.notify({
              time: 6000,
              title: 'Aviso',
              text: 'Erro ao renomear dispositivo. Tente novamente.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          });
      }
    },
    renomearDispositivoCancelar() {
      this.renomear.visivel = false;
    },
    excluirDispositivo(dispositivo) {
      let alias = dispositivo.alias || dispositivo.alias || dispositivo.device;

      console.log(dispositivo);

      let text = 'Atenção: Essa ação é irreversível! ' + 'Tem certeza que deseja excluir "' + alias + '"? ';
      if (dispositivo.status === 'ACTIVE') {
        text +=
          'Uma licença será gerada com os dias restantes para ser utilizada em outro dispositivo se a data de validade for superior ao dia de hoje. Se a data de validade é hoje, nenhuma licença será gerada.';
      } else {
        text += 'O dispositivo será excluído em 15 dias caso você não contrate um plano.';
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Excluir Dispositivo?',
        text: text,
        accept: () => {
          let url = '/api/v1/desktop/delete/' + dispositivo.licencekey;
          if (dispositivo.uid) {
            url = '/api/v1/mobile/delete/' + dispositivo.uid;
          }

          this.$api
            .delete(url, {
              dispositivo: dispositivo
            })
            .then(response => {
              this.$vs.notify({
                time: 6000,
                text: dispositivo.status === 'ACTIVE' ? 'Dispositivo Excluído com Sucesso' : response.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              });

              this.carregarDispositivos();
            })
            .catch(error => {
              console.log(error.response.data);
              this.$vs.notify({
                time: 6000,
                title: 'Aviso',
                text: error.response.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });

              this.carregarDispositivos();
            });
        },
        acceptText: 'Sim',
        cancelText: 'Não'
      });
    },
    acceptAlert() {
      this.$vs.notify({
        color: this.colorAlert,
        title: 'Liberado',
        text: 'conteudo liberado.'
      });
    }
  },
  watch: {
    filters: {
      handler() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          this.carregarDispositivos();
        }, 600);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
#demo-basic-card {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
      background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
      height: 370px;
    }
  }

  .demo-basic-card a {
    color: #fff !important;
  }
}

#loading {
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.superior {
  width: auto;
  height: auto;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: #fff;
  z-index: 1000;
  padding: 1rem;
}

.background {
  width: 100%;
  height: 100%;
}

.blur-all {
  backdrop-filter: blur(5px);
}
</style>
